// YERİ: src/app/domains/site/core/site-chrome-text.ts
//
// KİRACI SİTESİNİN KABUK METİNLERİ — ziyaretçiye görünen, koda ait dizeler.
//
// ── NEDEN PORTAL TRANSLOCO DEĞİL ───────────────────────────────────────────
// Portalın Transloco dili KİRACININ dilidir. Ziyaretçi bambaşka biri: kiracı
// portalı Türkçe kullanıyor diye ziyaretçiye Türkçe "Add to cart" gösterilemez.
// Site kendi dilini `ClientWebSetting.LanguageCode` alanından bildirir.
//
// ── NEDEN CMS İÇERİĞİ DEĞİL ────────────────────────────────────────────────
// Bunlar içerik değil, arayüz: "Sepete Ekle", "Uygun Saatler", "Tükendi".
// Kiracının düzenlemesi gereken şeyler olmadığı için veritabanına konmadı;
// sayfa/bölüm içeriği zaten CMS'ten geliyor.
//
// ── TEK DİL ────────────────────────────────────────────────────────────────
// Site TEK dilde yayınlanır. `ClientWebPageTranslation` (sayfa başına çeviri)
// tablosu iskelet hâlinde duruyor ama hiç kullanılmıyor; çok dilli site ayrı
// ve büyük bir iş. Bu servis o işi ENGELLEMEZ: çok dilli siteye geçilirse
// `dil` sinyalini besleyen kaynak değişir, çağıran kod aynı kalır.

import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TenantWebService } from './tenant-web.service';
import { SITE_CHROME_TEXTS } from './site-chrome-texts';

@Injectable({ providedIn: 'root' })
export class SiteChromeText {
  private svc = inject(TenantWebService);

  /**
   * Sitenin yayın dili. Ayar gelene kadar 'tr' — mevcut siteler bugün Türkçe
   * yayında, ilk boyamada başka bir dil gösterip sonra Türkçeye dönmek
   * gözle görülür bir titreme olurdu.
   */
  readonly dil = signal('tr');

  /**
   * Sitenin para birimi (ISO 4217). Katalog satırının kendi birimi yoksa
   * bölümler buna düşer. Varsayılan CAD — platformun para birimi bu;
   * eskiden sabit 'TRY'ye düşülüyordu ve Toronto'daki bir otel gecelik
   * ücretini ₺ ile ilan ediyordu.
   */
  readonly paraKodu = signal('CAD');

  /** clientId başına TEK istek; birden çok bileşen aynı sözü bekler. */
  private sozler = new Map<number, Promise<void>>();

  /**
   * Site ayarlarından dili çeker. Aynı clientId için tekrar çağrılması
   * güvenlidir. Ayar okunamazsa varsayılan dilde kalınır — site açılmalı.
   */
  yukle(clientId: number): Promise<void> {
    if (!clientId || clientId <= 0) return Promise.resolve();

    let soz = this.sozler.get(clientId);
    if (!soz) {
      soz = firstValueFrom(this.svc.getSettings(clientId))
        .then(s => {
          const kod = (s?.languageCode || '').trim().toLowerCase();
          if (kod) this.dil.set(kod);
          const para = (s?.currency || '').trim().toUpperCase();
          if (para) this.paraKodu.set(para);
        })
        // Söz SİLİNİR ki sonraki bileşen yeniden denesin; aksi halde tek ağ
        // hatası tüm oturum boyunca dili varsayılana kilitlerdi.
        .catch(() => { this.sozler.delete(clientId); });
      this.sozler.set(clientId, soz);
    }
    return soz;
  }

  /**
   * Kabuk metni. Bilinmeyen dil → İngilizce; o da yoksa Türkçe (kaynak dil);
   * anahtar hiç yoksa anahtarın kendisi — sessizce boş dönmek eksikliği
   * görünmez yapardı.
   */
  t(anahtar: string, params?: Record<string, string | number>): string {
    const sozluk = SITE_CHROME_TEXTS[anahtar];
    if (!sozluk) return anahtar;

    // 'en-ca' gibi bölgeli kodlar ana dile düşsün.
    const kod = (this.dil() || 'tr').toLowerCase().split('-')[0];
    let metin = sozluk[kod] ?? sozluk['en'] ?? sozluk['tr'] ?? anahtar;

    if (params) {
      for (const [k, v] of Object.entries(params)) {
        metin = metin.split(`{{${k}}}`).join(String(v));
      }
    }
    return metin;
  }
}
